import cloneDeep from "lodash/cloneDeep";
import escape from "lodash/escape";
import has from "lodash/has";
import isNil from "lodash/isNil";
import isNull from "lodash/isNull";
import isUndefined from "lodash/isUndefined";
import orderBy from "lodash/orderBy";
import unionBy from "lodash/unionBy";
import settings from "settings";
import { CHANGE_CLAN_ATTRIBUTES_SUCCESS } from "../Actions/ActionClanEdit";
import { getOrder } from "roles";
import { APPLICATIONS_UPDATE_CLAN_ACTIVE_APPLICATIONS } from "../Actions/ActionApp";
import {
  CLANS_CHANGE_TEAM_NUMBER,
  CLANS_CHANGE_BATTLE_TYPE,
  INCREASE_MAX_CLAN_SIZE,
  CLEAR_MEMBERS_OPERATION,
  SELECT_ROLE_MEMBERS_OPERATION,
  START_UPDATE_MEMBERS,
  TOGGLE_ALL_MEMBERS_TICK,
  TOGGLE_MEMBERS_SORTING,
  TOGGLE_MEMBER_TICK,
  UNTICK_CLAN_MEMBERS,
  UPDATE_MEMBERS,
  UPDATE_STATISTICS,
  START_UPDATE_CLAN,
  UPDATE_CLAN,
  UPDATE_CLAN_FROM_SYNC,
  UPDATE_WOWS_LADDER,
  UPDATE_ACHIEVEMENTS,
  DECREASE_CLAN_MEMBERS,
  INCREASE_CLAN_MEMBERS,
  DECREASE_CLAN_RESOURCE,
  SET_CLAN_PROFILE_CURRENT_SEASON,
  OPEN_CLAN_DESCRIPTION_DIALOG,
  CLOSE_CLAN_DESCRIPTION_DIALOG,
  OPEN_CLAN_DESCRIPTION_EDIT_DIALOG,
  CLOSE_CLAN_DESCRIPTION_EDIT_DIALOG,
  OPEN_CLAN_NAME_EDIT_DIALOG,
  CLOSE_CLAN_NAME_EDIT_DIALOG,
  OPEN_CLAN_RULES_DIALOG,
  CLOSE_CLAN_RULES_DIALOG,
  OPEN_OLD_RECOMMENDATIONS_DIALOG,
  CLOSE_OLD_RECOMMENDATIONS_DIALOG,
  OPEN_RECOMMENDATIONS_DIALOG,
  CLOSE_RECOMMENDATIONS_DIALOG,
  OPEN_LEAVE_DIALOG,
  CLOSE_LEAVE_DIALOG,
  SET_CLAN_PROFILE_CURRENT_SEASON_TYPE
} from "../Actions/ActionClanProfile";

const clanProfileInitialState = {
  isClanDescriptionDialogVisible: false,
  isClanDescriptionEditDialogVisible: false,
  isClanNameEditDialogVisible: false,
  isClanRulesDialogVisible: false,
  isRecommendationsDialogVisible: false,
  isOldRecommendationsDialogVisible: false,
  isLeaveDialogVisible: false
};

export const clanProfile = (state = clanProfileInitialState, action) => {
  switch (action.type) {
    case OPEN_LEAVE_DIALOG:
      {
        return {
          ...state,
          isLeaveDialogVisible: true
        };
      }
    case CLOSE_LEAVE_DIALOG:
      {
        return {
          ...state,
          isLeaveDialogVisible: false
        };
      }
    case OPEN_OLD_RECOMMENDATIONS_DIALOG: {
      return {
        ...state,
        isOldRecommendationsDialogVisible: true,
      }
    }
    case CLOSE_OLD_RECOMMENDATIONS_DIALOG: {
      return {
        ...state,
        isOldRecommendationsDialogVisible: false,
      }
    }
    case OPEN_RECOMMENDATIONS_DIALOG: {
      return {
        ...state,
        isRecommendationsDialogVisible: true,
      }
    }
    case CLOSE_RECOMMENDATIONS_DIALOG: {
      return {
        ...state,
        isRecommendationsDialogVisible: false,
      }
    }
    case OPEN_CLAN_RULES_DIALOG:
      {
        return {
          ...state,
          isClanRulesDialogVisible: true
        };
      }
    case CLOSE_CLAN_RULES_DIALOG:
      {
        return {
          ...state,
          isClanRulesDialogVisible: false
        };
      }
    case OPEN_CLAN_NAME_EDIT_DIALOG:
      {
        return {
          ...state,
          isClanNameEditDialogVisible: true
        };
      }
    case CLOSE_CLAN_NAME_EDIT_DIALOG:
      {
        return {
          ...state,
          isClanNameEditDialogVisible: false
        };
      }
    case OPEN_CLAN_DESCRIPTION_EDIT_DIALOG:
      {
        return {
          ...state,
          isClanDescriptionEditDialogVisible: true
        };
      }
    case CLOSE_CLAN_DESCRIPTION_EDIT_DIALOG:
      {
        return {
          ...state,
          isClanDescriptionEditDialogVisible: false
        };
      }
    case OPEN_CLAN_DESCRIPTION_DIALOG:
      {
        return {
          ...state,
          isClanDescriptionDialogVisible: true
        };
      }
    case CLOSE_CLAN_DESCRIPTION_DIALOG:
      {
        return {
          ...state,
          isClanDescriptionDialogVisible: false
        };
      }
    default:
      return state;

  }
};

const clansInitialState = {
  wowsLadder: {},
  isFetching: {},
  items: {},
  achievements: {}
};

export const clans = (state = clansInitialState, action) => {
  switch (action.type) {
    case START_UPDATE_CLAN:
      return {
        ...state,
        isFetching: {
          ...state.isFetching,
          [action.clanId]: true
        }
      };
    case UPDATE_CLAN:
      {
        const clan = action.clan;
        const clans = Object.assign({}, state.items, {
          [clan.id]: clan
        });
        return Object.assign({}, state, {
          items: clans,
          isFetching: {
            ...state.isFetching,
            [clan.id]: false
          }
        });
      }
    case UPDATE_CLAN_FROM_SYNC:
      {
        const clanId = action.clanId;
        const oldClan = state.items[clanId];
        if (!oldClan) return state;

        const newClanInfo = Object.assign({}, oldClan, action.clanInfo);
        const clans = Object.assign({}, state.items, {
          [clanId]: newClanInfo
        });
        return Object.assign({}, state, {
          items: clans
        });
      }
    case UPDATE_WOWS_LADDER:
      {
        const wowsLadder = state.wowsLadder;
        return {
          ...state,
          wowsLadder: {
            ...wowsLadder,
            [action.clanId]: action.wowsLadder
          }
        };
      }
    case UPDATE_ACHIEVEMENTS:
      {
        const achievements = state.achievements;
        return {
          ...state,
          achievements: {
            ...achievements,
            [action.clanId]: action.achievements
          }
        };
      }
    case INCREASE_MAX_CLAN_SIZE:
      {
        const clan = state.items[action.clanId];
        return {
          ...state,
          items: {
            ...state.items,
            [action.clanId]: {
              ...clan,
              maxMembersCount: clan.maxMembersCount + action.extraMembers
            }
          }
        };
      }
    case CHANGE_CLAN_ATTRIBUTES_SUCCESS:
      {
        const data = Object.assign({}, action.data);

        if (has(data, 'rawDescription')) {
          data.rawDescription = escape(data.rawDescription);
        }

        const clan = state.items[data.clanId];
        const clans = Object.assign({}, state.items, {
          [data.clanId]: Object.assign({}, clan, data)
        });

        return Object.assign({}, state, {
          items: clans
        });
      }
    case APPLICATIONS_UPDATE_CLAN_ACTIVE_APPLICATIONS:
      {
        const newState = cloneDeep(state);
        const clan = newState.items[action.clanId];
        if (clan) {
          clan.active_applications = unionBy(clan.active_applications, [{ id: action.applicationId }], 'id');
        }
        return newState;
      }
    case DECREASE_CLAN_MEMBERS:
      {
        const clan = cloneDeep(state.items[action.clanId]);
        clan.members_count -= action.count;
        const clans = Object.assign({}, state.items, {
          [clan.id]: clan
        });
        return {
          ...state,
          items: clans
        };
      }
    case INCREASE_CLAN_MEMBERS:
      {
        const clan = cloneDeep(state.items[action.clanId]);
        clan.members_count += action.count;
        const clans = Object.assign({}, state.items, {
          [clan.id]: clan
        });
        return {
          ...state,
          items: clans
        };
      }
    case DECREASE_CLAN_RESOURCE:
      {
        const clan = state.items[action.clanId];
        return {
          ...state,
          items: {
            ...state.items,
            [action.clanId]: {
              ...clan,
              personalResource: clan.personalResource - action.resource
            }
          }
        };
      }
    default:
      return state;

  }
};

const reverseOrder = order => order === 'asc' ? 'desc' : 'asc';

export const updateMembersForClan = (action, state) => {
  let {
    clanId,
    members,
    isFetching,
    error,
    hiddenSortingNames
  } = action;
  const clan = state.clans[clanId];

  if (!members) {
    members = clan.members;
  }
  const sort = action.sort || (clan && clan.sort) || {
    field: 'role',
    isAsc: true
  };

  let hiddenMembers = [];
  if (!isUndefined(hiddenSortingNames) && !hiddenSortingNames.includes(sort.field)) {
    hiddenMembers = members.filter(item => item.isHiddenStatistics);
    members = members.filter(item => !item.isHiddenStatistics);
  }

  if (sort) {
    const path = sort.field;
    const order = sort.isAsc ? 'asc' : 'desc';

    if (path === 'name') {
      members = orderBy(members, [item => item.name.toUpperCase()], order);
    } else if (path === 'rank') {
      const predicate = item => item.seasonRank === 0 || isNull(item.seasonRank);
      let membersWithZeroSeasonRank = members.filter(item => predicate(item));
      let membersWithNonZeroSeasonRank = members.filter(item => !predicate(item));

      membersWithZeroSeasonRank = orderBy(membersWithZeroSeasonRank, path, order);
      membersWithNonZeroSeasonRank = orderBy(membersWithNonZeroSeasonRank, 'seasonRank', reverseOrder(order));

      members = order === 'asc' ? [...membersWithZeroSeasonRank, ...membersWithNonZeroSeasonRank] : [...membersWithNonZeroSeasonRank, ...membersWithZeroSeasonRank];
    } else if (path === 'role') {
      members = orderBy(members, [member => getOrder(member.roleName), 'name'], order);
    } else if (path === 'lastBattleTime' || path === 'accumulativeClanResource') {
      let sortingMembers = [];
      const skippingMembers = [];
      members.forEach(member => {
        const value = member[path];
        const isSkipping = path === 'lastBattleTime' ? !value : isNil(value);
        isSkipping ? skippingMembers.push(member) : sortingMembers.push(member);
      });
      sortingMembers = orderBy(sortingMembers, path, order);

      members = [...sortingMembers, ...skippingMembers];
    } else {
      members = orderBy(members, path, order);
    }
  }

  members = members.concat(hiddenMembers);

  const nextClan = Object.assign({}, clan, {
    error,
    members,
    sort
  });
  return {
    ...state,
    isFetching: {
      ...state.isFetching,
      [clanId]: isFetching
    },
    clans: {
      ...state.clans,
      [clanId]: nextClan
    }
  };
};

const membersInitialState = {
  isFetching: {},
  clans: {},
  battleTypes: {},
  statistics: {},
  teamNumber: {},
  currentSeason: settings.ladder.lastSeasonId
};

export const members = (state = membersInitialState, action) => {
  switch (action.type) {
    case SET_CLAN_PROFILE_CURRENT_SEASON:
      return Object.assign({}, state, {
        currentSeason: action.currentSeason
      });
    case SET_CLAN_PROFILE_CURRENT_SEASON_TYPE:
      return Object.assign({}, state, {
        currentSeasonType: action.currentSeasonType
      });
    case UPDATE_MEMBERS: case TOGGLE_MEMBERS_SORTING:
      return updateMembersForClan(action, state);
    case START_UPDATE_MEMBERS:
      return {
        ...state,
        isFetching: {
          [action.clanId]: true
        }
      };
    case CLANS_CHANGE_BATTLE_TYPE:
      return Object.assign({}, state, {
        battleTypes: Object.assign({}, {
          [action.clanId]: action.battleType
        })
      });
    case CLANS_CHANGE_TEAM_NUMBER:
      return Object.assign({}, state, {
        teamNumber: Object.assign({}, {
          [action.clanId]: action.teamNumber
        })
      });
    case UPDATE_STATISTICS:
      {
        const isMissingStatistics = isUndefined((action.clanStatistics || {}).battles_count);
        const clans = Object.assign({}, state.statistics, {
          [action.clanId]: {
            statistics: action.clanStatistics,
            isMissingStatistics: isMissingStatistics,
            isHiddenStatistics: action.isHiddenStatistics
          }
        });
        return Object.assign({}, state, { statistics: clans });
      }
    default:
      return state;

  }
};

const membersOperationInitialState = {
  selectedIds: [],
  selectedRole: null
};

export const membersOperation = (state = membersOperationInitialState, action) => {
  let newState, newSelected;
  switch (action.type) {
    case UNTICK_CLAN_MEMBERS:
      newSelected = state.selectedIds.filter(m => !action.memberIds.includes(m));
      return Object.assign({}, state, {
        selectedIds: newSelected
      });
    case CLEAR_MEMBERS_OPERATION:
      return Object.assign({}, state, {
        selectedIds: [],
        selectedRole: null
      });
    case SELECT_ROLE_MEMBERS_OPERATION:
      return Object.assign({}, state, {
        selectedRole: action.roleName
      });
    case TOGGLE_ALL_MEMBERS_TICK:
      newState = Object.assign({}, state);

      if (newState.selectedIds.length === action.memberIds.length) {
        newState.selectedIds = [];
      } else {
        newState.selectedIds = action.memberIds;
      }

      return newState;
    case TOGGLE_MEMBER_TICK:
      newState = Object.assign({}, state);
      newSelected = newState.selectedIds.filter(m => m !== action.memberId);

      if (newSelected.length === newState.selectedIds.length) {
        newSelected.push(action.memberId);
      }

      newState.selectedIds = newSelected;
      return newState;
    default:
      return state;

  }
};